import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL VARIABLES
import { SELECT } from 'defaults.js';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// CORE COMPONENTS
import Sprite from 'core/tools/Sprite';

// STYLES
import styles from '../select.module.scss';

// MAIN COMPONENT
const Option = ({ children, className, innerProps, ...props }) => (
  <components.Option
    className={clsx(
      'select-option',
      styles.option,
      props.isSelected && styles.selected,
      props.isDisabled && styles.disabled,
      props.selectProps.isMulti && styles.multiple,
      className
    )}
    innerProps={Object.assign({}, innerProps, {
      'data-selected': props.isSelected,
      onClick: e => {
        const { name, formikBag: { setFieldTouched } } = props.selectProps;
        doCallback(setFieldTouched, name);
        doCallback(props.data.onClick || innerProps.onClick, e);
      }
    })}
    {...props}
  >
    {children}
    {!!props.isSelected &&
      <Sprite
        use={SELECT.selectedIcon}
      />
    }
  </components.Option>
)

// EXPORT
export default Option
